module.exports = __webpack_public_path__ + "static/media/createRooms.84c0e056.png";